import TextListTable from '@/components/TextListTable';
import { ModuleTextListTableFragment } from '@/graphql';
import { parseHtml } from '@/lib/parse-html';
import { notEmpty } from '@/lib/typescript-helpers';
import { getBrandColor } from '@/styles/color/utils';
import { FC } from 'react';

interface TextListTableModuleProps extends PropsWithClassName {
  props: CraftModuleFragment<ModuleTextListTableFragment>;
}

const TextListTableModule: FC<TextListTableModuleProps> = ({ props, className }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <TextListTable
      heading={props.heading ?? undefined}
      description={parseHtml(props.subheading)}
      tables={
        props.tables
          ?.map((table) => {
            const isOneColumn = table?.__typename === 'tables_oneColumn_BlockType';
            const isTwoColumns = table?.__typename === 'tables_twoColumns_BlockType';
            const isThreeColumns = table?.__typename === 'tables_threeColumns_BlockType';

            const columns = [
              {
                id: 1,
                title: table?.column1Heading ?? '',
                rows:
                  table?.column1Rows?.map((row) => ({
                    id: row?.text ?? '',
                    text: row?.text ?? '',
                    icon: row?.icon ?? '',
                  })) ?? [],
                footer: parseHtml(table?.column1Footer),
                backgroundColor: table?.column1Background?.label
                  ? getBrandColor(table.column1Background.label, 'tint') ?? undefined
                  : undefined,
              },
            ];

            if (isTwoColumns) {
              let column2Color = table?.column2Background?.label
                ? getBrandColor(table.column2Background.label, 'tint') ?? undefined
                : undefined;

              columns.push({
                id: 2,
                title: table?.column2Heading ?? '',
                rows:
                  table?.column2Rows?.map((row) => ({
                    id: row?.text ?? '',
                    text: row?.text ?? '',
                    icon: row?.icon ?? '',
                  })) ?? [],
                footer: parseHtml(table?.column2Footer),
                backgroundColor: column2Color,
              });
            }

            if (isThreeColumns) {
              let column2Color = table?.column2Background?.label
                ? getBrandColor(table.column2Background.label, 'tint') ?? undefined
                : undefined;

              columns.push({
                id: 3,
                title: table?.column3Heading ?? '',
                rows:
                  table?.column3Rows?.map((row) => ({
                    id: row?.text ?? '',
                    text: row?.text ?? '',
                    icon: row?.icon ?? '',
                  })) ?? [],
                footer: parseHtml(table?.column3Footer),
                backgroundColor: table?.column3Background?.label
                  ? getBrandColor(table.column3Background.label, 'tint') ?? column2Color
                  : column2Color,
              });
            }

            return {
              eyebrow: table?.eyebrow ?? undefined,
              description: parseHtml(table?.description),
              backgroundColor: table?.sectionBackground?.label
                ? getBrandColor(table.sectionBackground.label, 'tint') ?? undefined
                : undefined,
              columns,
              joinColumns: false,
            };
          })
          .filter(notEmpty) ?? []
      }
    />
  );
};

export default TextListTableModule;
